import { BufferGeometry, Material, Object3D } from 'three';
import { Text } from 'troika-three-text';

/**
 *  CLear all render data related to the object and its children to free up memory
 *
 *  NOTE. This clear the texture related to the materials.
 *  Might be an issue if textures are shared between objects.
 */
export const disposeRecursive = (object: Object3D) => {
  object.traverse((child: Object3D) => disposeObject(child));
};

const disposeObject = (
  object: Object3D & { geometry?: BufferGeometry; material?: Material | Material[] },
) => {
  if (object.geometry !== undefined) {
    object.geometry.dispose();
  }

  if (object instanceof Text) {
    object.dispose();
    return;
  }

  if (object.material !== undefined) {
    const materials: any[] = Array.isArray(object.material) ? object.material : [object.material];
    // Use any type instead of Material
    // Not all materials have any or all of possible textures defined
    // So check if exist, and if so, dispose them
    for (const material of materials) {
      if (material.map) {
        material.map.dispose();
      }
      if (material.lightMap) {
        material.lightMap.dispose();
      }
      if (material.bumpMap) {
        material.bumpMap.dispose();
      }
      if (material.normalMap) {
        material.normalMap.dispose();
      }
      if (material.specularMap) {
        material.specularMap.dispose();
      }
      if (material.envMap) {
        material.envMap.dispose();
      }

      material.dispose();
    }
  }
};
